module.exports = __webpack_public_path__ + "static/media/DSCF9969.14c2025f.jpg";